<div class="navbar-issuer">
  <div class="container">
    <nav class="navbar navbar-toggleable-md">
      <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarNavDropdown"
        aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
        <span> </span>
        <span> </span>
        <span> </span>
      </button>
      <span class="navbar-brand">
        <img src="{{Constant.logo_url_logo_1}}" />
      </span>
      <div class="collapse navbar-collapse" id="navbarNavDropdown">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item" routerLinkActive="active" (click)="changeCategory(PRODUCT)">
            <a class="nav-link" routerLink="{{Constant.url_issuer_issued_products}}" (click)="menuService.hide()">{{'navbar.category' | translate}}
              <span class="sr-only">(current)</span>
            </a>
          </li>
          <li class="nav-item dropdown" 
          routerLinkActive="active" (click)="changeCategory(CREATE)">
            <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
              aria-expanded="false">
              {{'navbar.create_product' | translate}}
            </a>
            <div class="dropdown-menu" 
            aria-labelledby="navbarDropdownMenuLink">
              <a class="dropdown-item create-fund"  routerLink="{{Constant.url_issuer_create_new_fund}}" routerLinkActive="active" (click)="menuService.hide()" *ngIf="issuerType === 'FUND_ISSUER'">{{'navbar.fund' | translate}}</a>
              <a class="dropdown-item create-gold" routerLink="{{Constant.path_create_gold}}" routerLinkActive="active" (click)="menuService.hide()" *ngIf="issuerType === 'GOLD_ISSUER'">{{'Vàng' | translate}}</a>
              <a class="dropdown-item create-gold" routerLink="{{Constant.path_create_gold}}" [queryParams]="{ type: 'SILVER'}" routerLinkActive="active" (click)="menuService.hide()" *ngIf="issuerType === 'GOLD_ISSUER'">{{'Bạc' | translate}}</a>
              <a class="dropdown-item create-bond" routerLink="{{Constant.path_create_bonds}}" routerLinkActive="active" (click)="menuService.hide()" *ngIf="issuerType === 'BOND_ISSUER'">{{'navbar.bond' | translate}}</a>
              <a class="dropdown-item create-cd" routerLink="{{Constant.path_create_certificate_deposit}}" routerLinkActive="active" (click)="menuService.hide()" *ngIf="issuerType === 'CD_ISSUER'">{{'navbar.cd' | translate}}</a>
            </div>
          </li>
          <!-- <li class="nav-item" routerLinkActive="active" (click)="changeCategory(REPORT)">
            <a class="nav-link" routerLink="{{Constant.path_issuer_report}}" (click)="menuService.hide()">{{'navbar.report' | translate}}</a>
          </li> -->
        </ul>
      </div>

      <div class="nav navbar-nav navbar-right">
        <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
          aria-expanded="false">
          <img src="{{Constant.icon_url_user_id}}" width="28">
        </a>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">
          <span class="dropdown-item code-num">{{accountNumber}}</span>
          <a class="dropdown-item" routerLink="{{Constant.url_issuer_profile}}" routerLinkActive="active" (click)="menuService.hide()">
            {{'navbar.account_information' | translate}}</a>
          <a class="dropdown-item" routerLink="{{Constant.path_help}}" routerLinkActive="active" (click)="menuService.hide()">{{'navbar.help' | translate}}</a>
          <a class="dropdown-item" routerLink="{{Constant.url_issuer_change_pass}}" routerLinkActive="active" (click)="menuService.hide()">
            {{'navbar.changePass' | translate}}</a>
          <a class="dropdown-item sign_out" (click)="signOut()">{{'navbar.sign_out' | translate}}</a>
        </div>
      </div>
    </nav>
  </div>
</div>
